"use client";
import { useEffect } from "react";

import { useAppContext } from "@/app/contextProviders/app-context";
import { dataLayerPush } from "@/lib/utils/dataLayerHelpers";

const PageView = () => {
  const { deviceType } = useAppContext();

  useEffect(() => {
    dataLayerPush({
      event: "virtual_page_view",
      brand: "Aspen Dental",
      site_section: "Scheduling",
      virtual_page_url: globalThis?.location?.href,
      virtual_page_title: globalThis?.document?.title,
      device_type: deviceType,
      page_origin_name: globalThis?.document?.title,
    });
  }, [deviceType]);

  return null;
};

export default PageView;
